import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';

@Injectable({
  providedIn: 'root'
})
export class Easy2Service {
  readonly http = inject(HttpClient);
  readonly snack = inject(SnackService)


  async checkAndCreateAccount(email: string, projectId: string, firstname?: string) {
    return new Promise((resolve) => {
      this.http.post(`${serverurl}/userlp_easy2/account`, { email, projectId, firstname }).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (error) => {
          this.snack.error(error);
          resolve(false);
        }
      })
    })
  }

  async createLandingPage() {
    return new Promise((resolve) => {
      this.http.post(`${serverurl}/userlp_easy2/landingPage`, {}).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (error) => {
          this.snack.error(error);
          resolve(false);
        }
      })
    })
  }

  async getLandingPageJSON(projectId: string): Promise<false | Object> {
    return new Promise((resolve) => {
      this.http.get(`${serverurl}/userlp_easy2/config/${projectId}`)
        .subscribe({
          next: (data) => resolve(data),
          error: (error) => {
            this.snack.error(error);
            resolve(false);
          }
        });
    });
  }
  async getInternLandingPageJSON(projectId: string): Promise<false | Object> {
    return new Promise((resolve) => {
      this.http.get(`${serverurl}/userlp_easy2/internlp/${projectId}`)
        .subscribe({
          next: (data) => resolve(data),
          error: (error) => {
            this.snack.error(error);
            resolve(false);
          }
        });
    });
  }
}
